import { shallowRef } from 'vue'

export const isCalendarFirestoreReady = shallowRef(false)

export const setCalendarFirestoreIsReady = (isReady) => {
  isCalendarFirestoreReady.value = isReady
}
